class InstagramSection extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    document.addEventListener('DOMContentLoaded', () => {
      this.waitForElements()
    })
  }

  waitForElements () {
    const customStyles = `
      /* BAO Custom Override styles */
      .grid-item .btn-item-wrap {
        .btn {
          --Button_Background: var(--Color_Anchor);
          --Button_Color: var(--Color_Brand);
          --Button_Background-hover: var(--Color_Brand);
          --Button_Color-hover: var(--Color_Anchor);
          --Border_Color: #e0e0e0;
          --Border_Color-hover: transparent;
          
          position: relative;
          z-index: 4;
          align-items: center;
          flex-shrink: 0;
          display: inline-flex;
          padding: 11px 41px 9px 20px;
          font-family: var(--Font_Family-rajdhani);
          font-size: 15px;
          font-weight: 600;
          letter-spacing: 0.03em;
          line-height: 110%;
          text-align: start;
          text-transform: uppercase;
          background-color: var(--Button_Background);
          border-color: var(--Border_Color);
          border-radius: 21px;
          color: var(--Button_Color);
          overflow: hidden;
          white-space: nowrap;
          &[disabled] {
            cursor: not-allowed;
            opacity: 0.5;
          }
          transition:
            background-color 0.5s ease,
            border-color 0.5s ease,
            color 0.5s ease;
          &:not([disabled]):hover {
            background-color: var(--Button_Background-hover);
            border-color: var(--Border_Color-hover);
            color: var(--Button_Color-hover);
            &::before {
              background-color: var(--Color_Red);
            }
          }
          &::after {
            position: absolute;
            top: 13px;
            right: 19px !important;
            left: auto !important;
            width: 6px !important;
            height: 9px !important;
            mask: url("data:image/svg+xml,%3Csvg viewBox='0 0 6 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M.754 7.9.4 8.252l.707.707.354-.354L4.857 5.21l.354-.354.353-.353-.353-.354-.354-.353L1.461.399 1.107.046.4.753l.354.353L4.15 4.503.754 7.899Z' fill='currentColor'/%3E%3C/svg%3E%0A");
            background-color: #fff;
          }
          &::before {
            content: '';
            position: absolute;
            right: 13px !important;
            top: 8px !important;
            background-color: var(--Color_Brand);
            border-radius: 50%;
            width: 18px;
            height: 18px;
            transition: background-color 0.5s ease;
          }
        }
        .overlay-effect {
          background: rgba(32, 32, 32, 0.5);
          backdrop-filter: blur(5px);
        }
      }

      .popup-body-content {
        .caption {
          font-family: var(--Font_Family-body);
          font-size: 15px;
          font-weight: 400;
          line-height: 130%;

          color: var(--Color_Brand);
        }
      }

      .post-video-element {
        width: 100% !important;

        video {
          object-fit: cover !important;
        }
      }

      .carousel-media .carousel-cell img {
        width: 100% !important;
        height: 100% !important;

        object-fit: cover !important;
      }

      .popup-dialog {
        @media only screen and (min-width: 800px) {
          max-width: 80vw !important;
        }
      }

      .popup-dialog,
      .share,
      .swiper-horizontal>.swiper-pagination-bullets {
        background-color: var(--Color_Grey) !important;
      }

      .btn-popup-close {
        align-items: center;
        justify-content: center;

        display: flex !important;
        border-radius: 50% !important;

        top: -60px !important;
        right: -60px !important;

        color: var(--Color_Brand) !important;

        background-color: #fff !important;

        transition: background-color 0.5s ease !important;

        &::after {
          content: '';

          width: 20px;
          height: 20px;

          mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath fill='currentColor' d='m14.338 4.338.99.99-9.837 9.837-.99-.99z'/%3E%3Cpath fill='currentColor' d='m15.336 14.338-.99.99L4.509 5.49l.99-.99z'/%3E%3C/svg%3E%0A");

          background-color: var(--Color_Brand);

          transition: background-color 0.5s ease;
        }

        &:hover {
          background-color: var(--Color_Red) !important;

          opacity: 1 !important;

          &::after {
            background-color: #fff;
          }
        }

        svg {
          display: none !important;
        }
      }

      .ctrl-arrow {
        align-items: center;
        justify-content: center;

        display: flex;

        position: relative;

        background-color: #fff !important;
        border-radius: 50% !important;

        width: 30px !important;
        height: 30px !important;

        transition: background-color 0.5s ease !important;

        &:hover {
          background-color: var(--Color_Red) !important;

          opacity: 1 !important;

          &::after {
            background-color: #fff;
          }
        }

        svg {
          display: none;
        }
      }

      .ctrl-next::after {
        content: '';

        width: 9px;
        height: 13px;

        mask: url("data:image/svg+xml,%3Csvg viewBox='0 0 6 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M.754 7.9.4 8.252l.707.707.354-.354L4.857 5.21l.354-.354.353-.353-.353-.354-.354-.353L1.461.399 1.107.046.4.753l.354.353L4.15 4.503.754 7.899Z' fill='currentColor'/%3E%3C/svg%3E%0A");

        background-color: var(--Color_Brand);

        transition: background-color 0.5s ease;
      } 

      .ctrl-prev::after {
        content: '';

        width: 9px;
        height: 13px;

        mask: url("data:image/svg+xml,%3Csvg viewBox='0 0 6 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.246 1.1 5.6.748 4.893.04l-.354.354L1.143 3.79l-.354.354-.353.353.353.354.354.353 3.396 3.397.354.353.707-.707-.354-.353L1.85 4.497l3.396-3.396Z' fill='currentColor'/%3E%3C/svg%3E%0A");

        background-color: var(--Color_Brand);

        transition: background-color 0.5s ease;
      }

      .desktop-arrows {
        .ctrl-next {
          right: -60px !important;

          width: 40px !important;
          height: 40px !important;
        }

        .ctrl-prev {
          left: -60px !important;

          width: 40px !important;
          height: 40px !important;
        }
      }

      .mobile-navigation {
        background-color: var(--Color_Grey) !important;
      }

      .mobile-arrows {
        gap: 10px;
        margin-left: var(--Site_Margin);
      }

      .mobile-buttons {
        .btn-close {
          align-items: center;
          justify-content: center;

          display: flex !important;
          background-color: #fff !important;

          border-radius: 50%;

          width: 30px !important;
          height: 30px !important;

          margin-right: var(--Site_Margin) !important;

          svg {
            display: none !important;          
          }

          &::after {
            content: '';

            width: 20px;
            height: 20px;

            mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath fill='currentColor' d='m14.338 4.338.99.99-9.837 9.837-.99-.99z'/%3E%3Cpath fill='currentColor' d='m15.336 14.338-.99.99L4.509 5.49l.99-.99z'/%3E%3C/svg%3E%0A");

            background-color: var(--Color_Brand);

            transition: background-color 0.5s ease;
          }
        }
      }

      .backdrop {
        background-color: rgba(32, 32, 32, 0.5);
      }

      .covet-branding {
        display: none !important;
      }
    `

    function injectStyles (element) {
      if (element.shadowRoot) {
        const style = document.createElement('style')
        style.textContent = customStyles
        element.shadowRoot.appendChild(style)
      }
    }

    const observer = new MutationObserver(() => {
      const widget = document.querySelector('covet-pics-widget')
      const popupWidget = document.querySelector('covet-pics-popup')

      if (widget && widget.shadowRoot) {
        injectStyles(widget)
      }

      if (popupWidget && popupWidget.shadowRoot) {
        injectStyles(popupWidget)
      }

      if (
        widget &&
        widget.shadowRoot &&
        popupWidget &&
        popupWidget.shadowRoot
      ) {
        observer.disconnect()
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })
  }
}

if (!customElements.get('instagram-section')) {
  customElements.define('instagram-section', InstagramSection)
}
